import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { validatePolish } from 'validate-polish';

export function regonValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value && !validatePolish.regon(String(control.value))) {
            return { invalidRegon: { value: control.value } };
        }

        return null;
    };
}
